export type CompareFunction<T> = (a: T, b: T) => number
export const compareCascade = <T>(...functions: CompareFunction<T>[]): CompareFunction<T> => {
  return (a: T, b: T): number => {
    for (const compareFunction of functions) {
      const result = compareFunction(a, b)
      if (result !== 0) {
        return result
      }
    }

    return 0
  }
}

export const compareString = (a: string, b: string): number => {
  return a.localeCompare(b)
}

export const compareStringNumeric = (a: string, b: string): number => {
  return a.localeCompare(b, undefined, {numeric: true})
}

export const compareByPosition = <T extends {position: number}>(a: T, b: T): number => {
  return a.position - b.position
}
